export default "__VITE_ASSET__DO3KYK1$__"